const promo = {
  en: {
    // Shared (used by both Promocodes.js and Discount.js)
    cancel: 'Cancel',
    editTitle: 'Edit',
    deleteTitle: 'Delete',
    clear: 'Clear',
    optional: '(optional)',

    // Promocodes.js
    title: 'Promocodes',
    subtitle: 'Create discount codes students redeem at checkout.',
    newPromocode: 'New promocode',
    statTotalCodes: 'Total codes',
    statActiveLabel: 'Active',
    statTotalRedemptions: 'Total redemptions',
    searchPlaceholder: 'Search code or name...',
    filterAll: 'All',
    filterActive: 'Active',
    filterInactive: 'Inactive',
    filterStatusAria: 'Filter by status',
    loading: 'Loading promocodes…',
    emptyTitleNone: 'No promocodes yet',
    emptyDescNone: 'Create your first code to run a promotion or reward loyal students.',
    emptyTitleFiltered: 'No matching promocodes',
    emptyDescFiltered: 'Try a different search or filter.',
    colCode: 'Code',
    colDiscount: 'Discount',
    colUsage: 'Usage',
    colValidity: 'Validity',
    colStatus: 'Status',
    colActions: 'Actions',
    copyCodeTitle: 'Copy code',
    courseFallback: 'Course',
    coursesCount: '{count} courses',
    unlimited: 'unlimited',
    activate: 'Activate',
    deactivate: 'Deactivate',
    statusExpired: 'Expired',
    statusScheduled: 'Scheduled',
    statusUsedUp: 'Used up',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    percentOff: '{value}% off',
    amountOff: '{amount} off',
    modalEditTitle: 'Edit promocode',
    modalNewTitle: 'New promocode',
    codeLabel: 'Code',
    codePlaceholder: 'SUMMER25',
    generate: 'Random',
    nameLabel: 'Name',
    namePlaceholder: 'Summer sale',
    discountTypeLabel: 'Discount type',
    percentageOption: 'Percentage (%)',
    fixedAmountOption: 'Fixed amount (UZS)',
    percentOffLabel: 'Percent off',
    amountOffLabelUZS: 'Amount off (UZS)',
    appliesToLabel: 'Applies to',
    allCoursesTitle: 'All courses',
    specificCoursesTitle: 'Specific courses',
    specificCoursesDesc: 'Pick which courses',
    noCoursesFound: 'No courses found — create a course first.',
    coursesSelected: '{selected} of {total} selected',
    startsLabel: 'Starts',
    expiresLabel: 'Expires',
    maxUsesLabel: 'Max total uses',
    maxUsesHint: 'Leave empty for no limit',
    maxPerStudentLabel: 'Max per student',
    minOrderLabel: 'Minimum order amount (UZS)',
    activeRowLabel: 'Active — students can redeem this code right away',
    saveChanges: 'Save changes',
    createPromocode: 'Create promocode',
    deleteConfirmTitle: 'Delete promocode?',
    deleteConfirmMsg: "{code} can no longer be redeemed. This can't be undone.",
    errCodeRequired: 'A code is required.',
    errValidValue: 'Enter a valid discount value.',
    errPercentRange: 'Percentage must be between 0 and 100.',
    errPickCourse: 'Pick at least one course, or switch to “All courses”.',
    errEndAfterStart: 'End date must be after the start date.',
    errLimits: 'A usage limit must be a whole number, 1 or more.',
    errSaveFailed: 'Failed to save. The code may already exist.',
    toastUpdated: 'Promocode updated',
    toastCreated: 'Promocode created',
    toastStatusFailed: 'Could not update status',
    toastDeleted: 'Promocode deleted',
    toastDeleteFailed: 'Failed to delete',
    toastCopied: 'Copied {code}',
    toastCopyFailed: 'Could not copy the code',
    defaultName: 'Promo {code}',
    validFrom: 'from {date}',
    validUntil: 'until {date}',
    validOpen: 'No expiry',
    durationAria: 'Validity length',
    durationDays: '{count} days',
    clearFilters: 'Clear filters',

    // Discount.js
    discTitle: 'Discounts and coupons',
    discSubtitle: 'Create and manage promotional codes for your courses',
    discNewDiscount: 'New discount',
    discStatTotal: 'Total',
    discStatActive: 'Active',
    discStatInactive: 'Inactive',
    discStatWithCode: 'With code',
    discStatTotalUses: 'Total uses',
    discSearchPlaceholder: 'Search by name or code...',
    discFilterAll: 'All',
    discFilterActive: 'Active',
    discFilterInactive: 'Inactive',
    discFilterAllTypes: 'All types',
    discFilterPercentage: 'Percentage',
    discFilterFixedAmount: 'Fixed amount',
    discFilterTypeAria: 'Filter by type',
    discColName: 'Name',
    discColCode: 'Code',
    discColValue: 'Value',
    discColScope: 'Scope',
    discColUsage: 'Usage',
    discColExpires: 'Expires',
    discColStatus: 'Status',
    discUnlimited: 'Unlimited',
    discNoExpiry: 'No expiry',
    discEmptyTitle: 'No discounts yet',
    discEmptyDesc: 'Create your first discount or coupon code to attract more students',
    discEmptyAction: 'Create the first discount',
    discDeleteConfirm: 'Delete "{name}"?',
    discDeleteWarning: 'This cannot be undone. Anyone with this code will no longer be able to use it.',
    discToastDeactivated: 'Discount deactivated',
    discToastActivated: 'Discount activated',
    discToastStatusFailed: 'Failed to update status',
    discToastDeleted: 'Discount deleted',
    discToastDeleteFailed: 'Failed to delete',
    discToastCopied: 'Copied: {code}',
    discToastUpdated: 'Discount updated',
    discToastCreated: 'Discount created',
    discModalEditTitle: 'Edit discount',
    discModalCreateTitle: 'Create discount',
    discNameLabel: 'Name',
    discNamePlaceholder: 'Summer sale 20%',
    discDescriptionLabel: 'Description',
    discDescriptionPlaceholder: 'Optional description...',
    discCouponCodeLabel: 'Coupon code',
    discCouponCodePlaceholder: 'SAVE20 (optional)',
    discCouponCodeHint: 'Leave empty for automatic discounts',
    discScopeLabel: 'Scope',
    discScopeGlobal: 'Global (all courses)',
    discScopeCourse: 'Specific courses',
    discScopeCategory: 'Category',
    discScopeUser: 'Specific users',
    discScopeAria: 'Discount scope',
    discTypeLabel: 'Discount type',
    discTypePercentage: 'Percentage (%)',
    discTypeFixed: 'Fixed amount',
    discValueLabel: 'Value',
    discValuePercentPlaceholder: 'e.g. 20',
    discValueFixedPlaceholder: 'e.g. 50000',
    discMaxUsesLabel: 'Max uses',
    discStartsAtLabel: 'Starts',
    discExpiresAtLabel: 'Expires',
    discMinOrderLabel: 'Min order (UZS)',
    discMinOrderPlaceholder: 'No minimum',
    discActiveLabel: 'Active',
    discSaveChanges: 'Save changes',
    discCreate: 'Create discount',
    discErrNameRequired: 'Name is required',
    discErrValueRequired: 'Valid value is required',
    discErrPercentRange: 'Percentage must be 0–100',
    discErrSaveFailed: 'Failed to save discount. Please try again.',
  },
  ru: {
    // Shared
    cancel: 'Отмена',
    editTitle: 'Редактировать',
    deleteTitle: 'Удалить',
    clear: 'Очистить',
    optional: '(необязательно)',

    // Promocodes.js
    title: 'Промокоды',
    subtitle: 'Создавайте промокоды, которые студенты применяют при оформлении заказа.',
    newPromocode: 'Новый промокод',
    statTotalCodes: 'Всего кодов',
    statActiveLabel: 'Активные',
    statTotalRedemptions: 'Всего использований',
    searchPlaceholder: 'Поиск по коду или названию...',
    filterAll: 'Все',
    filterActive: 'Активные',
    filterInactive: 'Неактивные',
    filterStatusAria: 'Фильтр по статусу',
    loading: 'Загрузка промокодов…',
    emptyTitleNone: 'Пока нет промокодов',
    emptyDescNone: 'Создайте свой первый код для проведения акции или поощрения постоянных студентов.',
    emptyTitleFiltered: 'Совпадений не найдено',
    emptyDescFiltered: 'Попробуйте изменить поиск или фильтр.',
    colCode: 'Код',
    colDiscount: 'Скидка',
    colUsage: 'Использование',
    colValidity: 'Срок действия',
    colStatus: 'Статус',
    colActions: 'Действия',
    copyCodeTitle: 'Скопировать код',
    courseFallback: 'Курс',
    coursesCount: '{count} курсов',
    unlimited: 'без ограничений',
    activate: 'Активировать',
    deactivate: 'Деактивировать',
    statusExpired: 'Истёк',
    statusScheduled: 'Запланирован',
    statusUsedUp: 'Исчерпан',
    statusActive: 'Активен',
    statusInactive: 'Неактивен',
    percentOff: 'Скидка {value}%',
    amountOff: 'Скидка {amount}',
    modalEditTitle: 'Редактировать промокод',
    modalNewTitle: 'Новый промокод',
    codeLabel: 'Код',
    codePlaceholder: 'SUMMER25',
    generate: 'Случайный',
    nameLabel: 'Название',
    namePlaceholder: 'Летняя распродажа',
    discountTypeLabel: 'Тип скидки',
    percentageOption: 'Процент (%)',
    fixedAmountOption: 'Фиксированная сумма (сум)',
    percentOffLabel: 'Процент скидки',
    amountOffLabelUZS: 'Сумма скидки (сум)',
    appliesToLabel: 'Применяется к',
    allCoursesTitle: 'Все курсы',
    specificCoursesTitle: 'Определённые курсы',
    specificCoursesDesc: 'Выберите курсы',
    noCoursesFound: 'Курсы не найдены — сначала создайте курс.',
    coursesSelected: 'Выбрано {selected} из {total}',
    startsLabel: 'Начало',
    expiresLabel: 'Окончание',
    maxUsesLabel: 'Макс. количество использований',
    maxUsesHint: 'Пусто — без ограничений',
    maxPerStudentLabel: 'Макс. на одного студента',
    minOrderLabel: 'Минимальная сумма заказа (сум)',
    activeRowLabel: 'Активен — студенты могут сразу использовать этот код',
    saveChanges: 'Сохранить изменения',
    createPromocode: 'Создать промокод',
    deleteConfirmTitle: 'Удалить промокод?',
    deleteConfirmMsg: '{code} больше нельзя будет применить. Это действие нельзя отменить.',
    errCodeRequired: 'Код обязателен.',
    errValidValue: 'Введите корректное значение скидки.',
    errPercentRange: 'Процент должен быть от 0 до 100.',
    errPickCourse: 'Выберите хотя бы один курс или переключитесь на «Все курсы».',
    errEndAfterStart: 'Дата окончания должна быть позже даты начала.',
    errLimits: 'Лимит использований — целое число от 1.',
    errSaveFailed: 'Не удалось сохранить. Возможно, такой код уже существует.',
    toastUpdated: 'Промокод обновлён',
    toastCreated: 'Промокод создан',
    toastStatusFailed: 'Не удалось изменить статус',
    toastDeleted: 'Промокод удалён',
    toastDeleteFailed: 'Не удалось удалить',
    toastCopied: 'Скопировано {code}',
    toastCopyFailed: 'Не удалось скопировать код',
    defaultName: 'Промокод {code}',
    validFrom: 'с {date}',
    validUntil: 'до {date}',
    validOpen: 'Бессрочно',
    durationAria: 'Длительность',
    durationDays: '{count} дней',
    clearFilters: 'Сбросить фильтры',

    // Discount.js
    discTitle: 'Скидки и купоны',
    discSubtitle: 'Создавайте промокоды для ваших курсов и управляйте ими',
    discNewDiscount: 'Новая скидка',
    discStatTotal: 'Всего',
    discStatActive: 'Активные',
    discStatInactive: 'Неактивные',
    discStatWithCode: 'С кодом',
    discStatTotalUses: 'Всего использований',
    discSearchPlaceholder: 'Поиск по названию или коду...',
    discFilterAll: 'Все',
    discFilterActive: 'Активные',
    discFilterInactive: 'Неактивные',
    discFilterAllTypes: 'Все типы',
    discFilterPercentage: 'Процент',
    discFilterFixedAmount: 'Фиксированная сумма',
    discFilterTypeAria: 'Фильтр по типу',
    discColName: 'Название',
    discColCode: 'Код',
    discColValue: 'Значение',
    discColScope: 'Область',
    discColUsage: 'Использование',
    discColExpires: 'Истекает',
    discColStatus: 'Статус',
    discUnlimited: 'Без ограничений',
    discNoExpiry: 'Без срока',
    discEmptyTitle: 'Пока нет скидок',
    discEmptyDesc: 'Создайте свою первую скидку или купон, чтобы привлечь больше студентов',
    discEmptyAction: 'Создать первую скидку',
    discDeleteConfirm: 'Удалить «{name}»?',
    discDeleteWarning: 'Это действие нельзя отменить. Никто больше не сможет использовать этот код.',
    discToastDeactivated: 'Скидка деактивирована',
    discToastActivated: 'Скидка активирована',
    discToastStatusFailed: 'Не удалось изменить статус',
    discToastDeleted: 'Скидка удалена',
    discToastDeleteFailed: 'Не удалось удалить',
    discToastCopied: 'Скопировано: {code}',
    discToastUpdated: 'Скидка обновлена',
    discToastCreated: 'Скидка создана',
    discModalEditTitle: 'Редактировать скидку',
    discModalCreateTitle: 'Создать скидку',
    discNameLabel: 'Название',
    discNamePlaceholder: 'Летняя распродажа 20%',
    discDescriptionLabel: 'Описание',
    discDescriptionPlaceholder: 'Необязательное описание...',
    discCouponCodeLabel: 'Код купона',
    discCouponCodePlaceholder: 'SAVE20 (необязательно)',
    discCouponCodeHint: 'Оставьте пустым для автоматических скидок',
    discScopeLabel: 'Область действия',
    discScopeGlobal: 'Глобально (все курсы)',
    discScopeCourse: 'Определённые курсы',
    discScopeCategory: 'Категория',
    discScopeUser: 'Определённые пользователи',
    discScopeAria: 'Область действия скидки',
    discTypeLabel: 'Тип скидки',
    discTypePercentage: 'Процент (%)',
    discTypeFixed: 'Фиксированная сумма',
    discValueLabel: 'Значение',
    discValuePercentPlaceholder: 'напр. 20',
    discValueFixedPlaceholder: 'напр. 50000',
    discMaxUsesLabel: 'Макс. использований',
    discStartsAtLabel: 'Дата начала',
    discExpiresAtLabel: 'Дата окончания',
    discMinOrderLabel: 'Мин. заказ (сум)',
    discMinOrderPlaceholder: 'Без минимума',
    discActiveLabel: 'Активен',
    discSaveChanges: 'Сохранить изменения',
    discCreate: 'Создать скидку',
    discErrNameRequired: 'Название обязательно',
    discErrValueRequired: 'Требуется корректное значение',
    discErrPercentRange: 'Процент должен быть от 0 до 100',
    discErrSaveFailed: 'Не удалось сохранить скидку. Попробуйте снова.',
  },
  uz: {
    // Shared
    cancel: 'Bekor qilish',
    editTitle: 'Tahrirlash',
    deleteTitle: "O'chirish",
    clear: 'Tozalash',
    optional: '(ixtiyoriy)',

    // Promocodes.js
    title: 'Promokodlar',
    subtitle: "O'quvchilar xarid vaqtida ishlatadigan chegirma kodlarini yarating.",
    newPromocode: 'Yangi promokod',
    statTotalCodes: 'Jami kodlar',
    statActiveLabel: 'Faol',
    statTotalRedemptions: 'Jami foydalanishlar',
    searchPlaceholder: "Kod yoki nom bo'yicha qidirish...",
    filterAll: 'Barchasi',
    filterActive: 'Faol',
    filterInactive: 'Nofaol',
    filterStatusAria: "Holat bo'yicha filtr",
    loading: 'Promokodlar yuklanmoqda…',
    emptyTitleNone: "Hozircha promokodlar yo'q",
    emptyDescNone: "Aksiya o'tkazish yoki sodiq o'quvchilarni rag'batlantirish uchun birinchi kodingizni yarating.",
    emptyTitleFiltered: 'Mos promokodlar topilmadi',
    emptyDescFiltered: "Boshqa qidiruv yoki filtrni sinab ko'ring.",
    colCode: 'Kod',
    colDiscount: 'Chegirma',
    colUsage: 'Foydalanish',
    colValidity: 'Amal qilish muddati',
    colStatus: 'Holat',
    colActions: 'Amallar',
    copyCodeTitle: 'Kodni nusxalash',
    courseFallback: 'Kurs',
    coursesCount: '{count} ta kurs',
    unlimited: 'cheksiz',
    activate: 'Faollashtirish',
    deactivate: 'Faolsizlantirish',
    statusExpired: "Muddati o'tgan",
    statusScheduled: 'Rejalashtirilgan',
    statusUsedUp: 'Limiti tugagan',
    statusActive: 'Faol',
    statusInactive: 'Nofaol',
    percentOff: '{value}% chegirma',
    amountOff: '{amount} chegirma',
    modalEditTitle: 'Promokodni tahrirlash',
    modalNewTitle: 'Yangi promokod',
    codeLabel: 'Kod',
    codePlaceholder: 'SUMMER25',
    generate: 'Tasodifiy',
    nameLabel: 'Nomi',
    namePlaceholder: 'Yozgi chegirma',
    discountTypeLabel: 'Chegirma turi',
    percentageOption: 'Foiz (%)',
    fixedAmountOption: "Belgilangan summa (so'm)",
    percentOffLabel: 'Chegirma foizi',
    amountOffLabelUZS: "Chegirma summasi (so'm)",
    appliesToLabel: "Qo'llaniladi",
    allCoursesTitle: 'Barcha kurslar',
    specificCoursesTitle: 'Aniq kurslar',
    specificCoursesDesc: 'Kurslarni tanlang',
    noCoursesFound: "Kurslar topilmadi — avval kurs yarating.",
    coursesSelected: "{total} tadan {selected} tasi tanlandi",
    startsLabel: 'Boshlanishi',
    expiresLabel: 'Tugashi',
    maxUsesLabel: 'Maksimal foydalanish soni',
    maxUsesHint: "Bo'sh qoldirilsa, cheklov yo'q",
    maxPerStudentLabel: "Bitta o'quvchi uchun maksimal",
    minOrderLabel: "Minimal buyurtma summasi (so'm)",
    activeRowLabel: "Faol — o'quvchilar bu koddan darhol foydalanishi mumkin",
    saveChanges: "O'zgarishlarni saqlash",
    createPromocode: 'Promokod yaratish',
    deleteConfirmTitle: "Promokod o'chirilsinmi?",
    deleteConfirmMsg: "{code} kodidan endi foydalanib bo'lmaydi. Bu amalni bekor qilib bo'lmaydi.",
    errCodeRequired: 'Kod kiritilishi shart.',
    errValidValue: "To'g'ri chegirma qiymatini kiriting.",
    errPercentRange: "Foiz 0 dan 100 gacha bo'lishi kerak.",
    errPickCourse: "Kamida bitta kursni tanlang yoki «Barcha kurslar»ga o'ting.",
    errEndAfterStart: "Tugash sanasi boshlanish sanasidan keyin bo'lishi kerak.",
    errLimits: "Foydalanish chegarasi 1 dan kam bo'lmagan butun son bo'lishi kerak.",
    errSaveFailed: "Saqlab bo'lmadi. Bunday kod allaqachon mavjud bo'lishi mumkin.",
    toastUpdated: 'Promokod yangilandi',
    toastCreated: 'Promokod yaratildi',
    toastStatusFailed: "Holatni o'zgartirib bo'lmadi",
    toastDeleted: "Promokod o'chirildi",
    toastDeleteFailed: "O'chirib bo'lmadi",
    toastCopied: '{code} nusxalandi',
    toastCopyFailed: "Kodni nusxalab bo'lmadi",
    defaultName: 'Promokod {code}',
    validFrom: '{date} dan',
    validUntil: '{date} gacha',
    validOpen: 'Muddatsiz',
    durationAria: 'Davomiyligi',
    durationDays: '{count} kun',
    clearFilters: 'Filtrlarni tozalash',

    // Discount.js
    discTitle: 'Chegirmalar va kuponlar',
    discSubtitle: 'Kurslaringiz uchun promokodlarni yarating va boshqaring',
    discNewDiscount: 'Yangi chegirma',
    discStatTotal: 'Jami',
    discStatActive: 'Faol',
    discStatInactive: 'Nofaol',
    discStatWithCode: 'Kodli',
    discStatTotalUses: 'Jami foydalanishlar',
    discSearchPlaceholder: "Nom yoki kod bo'yicha qidirish...",
    discFilterAll: 'Barchasi',
    discFilterActive: 'Faol',
    discFilterInactive: 'Nofaol',
    discFilterAllTypes: 'Barcha turlar',
    discFilterPercentage: 'Foiz',
    discFilterFixedAmount: 'Belgilangan summa',
    discFilterTypeAria: "Tur bo'yicha filtr",
    discColName: 'Nomi',
    discColCode: 'Kod',
    discColValue: 'Qiymati',
    discColScope: 'Qamrov',
    discColUsage: 'Foydalanish',
    discColExpires: 'Tugash sanasi',
    discColStatus: 'Holat',
    discUnlimited: 'Cheksiz',
    discNoExpiry: 'Muddatsiz',
    discEmptyTitle: "Hozircha chegirmalar yo'q",
    discEmptyDesc: "Ko'proq o'quvchi jalb qilish uchun birinchi chegirma yoki kupon kodingizni yarating",
    discEmptyAction: 'Birinchi chegirmani yaratish',
    discDeleteConfirm: "«{name}» o'chirilsinmi?",
    discDeleteWarning: "Bu amalni bekor qilib bo'lmaydi. Bu koddan endi hech kim foydalana olmaydi.",
    discToastDeactivated: 'Chegirma faolsizlantirildi',
    discToastActivated: 'Chegirma faollashtirildi',
    discToastStatusFailed: "Holatni yangilab bo'lmadi",
    discToastDeleted: "Chegirma o'chirildi",
    discToastDeleteFailed: "O'chirib bo'lmadi",
    discToastCopied: 'Nusxalandi: {code}',
    discToastUpdated: 'Chegirma yangilandi',
    discToastCreated: 'Chegirma yaratildi',
    discModalEditTitle: 'Chegirmani tahrirlash',
    discModalCreateTitle: 'Chegirma yaratish',
    discNameLabel: 'Nomi',
    discNamePlaceholder: 'Yozgi sotuv 20%',
    discDescriptionLabel: 'Tavsif',
    discDescriptionPlaceholder: 'Ixtiyoriy tavsif...',
    discCouponCodeLabel: 'Kupon kodi',
    discCouponCodePlaceholder: 'SAVE20 (ixtiyoriy)',
    discCouponCodeHint: "Avtomatik chegirmalar uchun bo'sh qoldiring",
    discScopeLabel: 'Qamrov',
    discScopeGlobal: 'Global (barcha kurslar)',
    discScopeCourse: 'Aniq kurslar',
    discScopeCategory: 'Kategoriya',
    discScopeUser: 'Aniq foydalanuvchilar',
    discScopeAria: 'Chegirma qamrovi',
    discTypeLabel: 'Chegirma turi',
    discTypePercentage: 'Foiz (%)',
    discTypeFixed: 'Belgilangan summa',
    discValueLabel: 'Qiymati',
    discValuePercentPlaceholder: 'masalan, 20',
    discValueFixedPlaceholder: 'masalan, 50000',
    discMaxUsesLabel: 'Maksimal foydalanish',
    discStartsAtLabel: 'Boshlanish sanasi',
    discExpiresAtLabel: 'Tugash sanasi',
    discMinOrderLabel: "Minimal buyurtma (so'm)",
    discMinOrderPlaceholder: "Minimal yo'q",
    discActiveLabel: 'Faol',
    discSaveChanges: "O'zgarishlarni saqlash",
    discCreate: 'Chegirma yaratish',
    discErrNameRequired: 'Nomi kiritilishi shart',
    discErrValueRequired: "To'g'ri qiymat talab qilinadi",
    discErrPercentRange: "Foiz 0–100 oralig'ida bo'lishi kerak",
    discErrSaveFailed: "Chegirmani saqlab bo'lmadi. Qaytadan urinib ko'ring.",
  },
};

export default promo;
